export default __webpack_public_path__ + "static/media/8.39633882.png";